import React from "react";
import { Modal } from "react-bootstrap";

function ModalWindow({ show, id, handleClose, modalTitle, component: Component, ...props }) {
  return (
    <Modal
      size="lg"
      show={show === id}
      onHide={() => handleClose()}
      backdrop="static"
      keyboard={false}
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton style={{ backgroundColor: "#157995", color: "#fff" }}>
        <Modal.Title id="contained-modal-title-vcenter">{modalTitle}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Component
              show={show}
              id={id}
              handleClose={handleClose}
              {...props} />
      </Modal.Body>
    </Modal>
  );
}

export default ModalWindow;
